import { Avatar } from '@repletoryreach/sdk-ui';

/**
 * The organisation's initial in a tinted tile.
 *
 * The reference designs show a real logo on every tenant row. We store no
 * logo, so rather than an empty square this uses the initial-letter avatar the
 * console already uses for people and tenants elsewhere.
 */
export function TenantAvatar({ name, size = 'sm' }: { name: string; size?: 'xs' | 'sm' | 'md' | 'lg' }) {
  return (
    <Avatar
      size={size}
      radius="md"
      aria-hidden
      style={{
        background: 'color-mix(in srgb, var(--rr-color-primary) 14%, transparent)',
        color: 'var(--rr-color-primary)',
        fontWeight: 700
      }}
    >
      {name.slice(0, 1).toUpperCase()}
    </Avatar>
  );
}
